import { render, staticRenderFns } from "./AfterEmailConfirmation.vue?vue&type=template&id=db2baba2"
import script from "./AfterEmailConfirmation.vue?vue&type=script&lang=js"
export * from "./AfterEmailConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports